<script>
import axios from 'axios';
import Logo from './WhatsappLogo.vue';
import Input from '../../components/base/Input';

export default {
  components: {
    Logo,
    Input,
  },

  props: {
    /**
     * The whatsapp integration
     *
     * with: config and phone
     */
    whatsapp: {
      type: Object,
      required: true,
    },

    /**
     * The tenant token
     */
    token: {
      type: String,
      required: true,
    }
  },

  data: () => ({
    show: false,
    loading: false,
    form: {
      name: '',
      email: '',
      phone: '',
    }
  }),

  methods: {
    start () {
      const {
        phone = '',
      } = this.whatsapp.config || {};

      this.loading = 'Redirecionando...';

      axios
        .post(`https://api.salesflowcrm.com.br/conversion/${this.token}`, this.form)
        .then(() => {
          window.location.href = `https://wa.me/55${phone.replace(/\D/g, "")}`;
        })
        .finally(() => this.loading = false);
    },
  },
};
</script>

<template>
  <div
    class="bdk-preflight bdk-z-50 bdk-w-auto bdk-badge bdk-fixed bdk-left-0 bdk-bottom-0 bdk-pb-2 bdk-pl-2"
  >
    <div
      v-if="show"
      class="bdk-w-96 bdk-inline-block bdk-align-bottom bdk-rounded-lg bdk-px-6 bdk-pb-4 bdk-text-left bdk-overflow-hidden bdk-shadow-xl sm:bdk-align-middle bdk-max-w-sm bdk-bg-wppbg"
    >
      <div
        class="bdk-px-8 bdk-py-2 bdk-flex bdk-bg-wpp bdk--mx-8 bdk-mb-4 bdk-justify-between"
      >
        <span
          v-text="__('Olá! Preencha os campos abaixo para iniciar a conversa no WhatsApp')"
          class="bdk-block bdk-text-base bdk-text-white bdk-text-left"
        />

        <button
          @click.prevent="show = false"
          class="bdk-flex bdk-items-start bdk-mt-1 bdk-text-white bdk-ml-2"
        >
          <svg
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            class="bdk-h-4 bdk-w-4"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <form
        @submit.prevent="start"
      >
        <Input
          required
          color="green-500"
          placeholder="Nome"
          v-model="form.name"
        />

        <Input
          required
          type="email"
          class="bdk-mt-4"
          color="green-500"
          placeholder="Email"
          v-model="form.email"
        />

        <Input
          required
          class="bdk-mt-4"
          color="green-500"
          v-model="form.phone"
          placeholder="Telefone"
          mask="(##) # ####-####"
        />

        <button
          type="submit"
          v-if="! loading"
          v-text="__('Iniciar Conversa')"
          class="bdk-mt-4 bdk-bg-wpp bdk-text-white bdk-w-full bdk-inline-flex bdk-justify-center bdk-items-center bdk-px-6 bdk-py-3 bdk-border bdk-border-transparent bdk-text-base bdk-font-medium bdk-rounded-md bdk-shadow-sm focus:bdk-outline-none"
        />

        <button
          v-else
          :disabled="loading"
          @click.prevent.stop
          class="bdk-mt-4 bdk-bg-wpp bdk-text-white bdk-w-full bdk-inline-flex bdk-justify-center bdk-items-center bdk-px-6 bdk-py-3 bdk-border bdk-border-transparent bdk-text-base bdk-font-medium bdk-rounded-md bdk-shadow-sm focus:bdk-outline-none"
        >
          <span
            v-text="loading"
            class="bdk-text-base bdk-font-medium"
          />

          <div
            class="bdk-w-4 bdk-h-4 bdk-ml-2 bdk-animate-spin bdk-rounded-full bdk-border-2 bdk-border-transparent bdk-border-l-white"
          />
        </button>
      </form>
    </div>

    <button
      @click.prevent="show = ! show"
      class="bdk-rounded-tl-md bdk-rounded-bl-md bdk-flex bdk-items-start bdk-px-2.5 bdk-py-1.5 bdk-pl-2 bdk-flex-col"
    >
      <Logo/>
    </button>
  </div>
</template>
